const nakiRadioUserAccessType = {
    free: 0,
    premium: 1,
};

export default nakiRadioUserAccessType;
